import React from "react";
import { withRouter } from "react-router-dom";
import {
    updateEvent,
} from "../../../redux/actions/events";
import { connect } from "react-redux";
import PricingForm from "../../../components/events/pricingForm";

const EventPricing = ({ eventId, ...props }) => {

    const dispatchUpdateEvent = (eventPricing) => {

        const event = { ...props.selectedEvent };

        event.pricingData = {
            unitPrice: eventPricing.unitPrice || event.unitPrice || 0,
            volumePricing: eventPricing.volumePricing || event.volumePricing || null,
            fullSelfiePrice: eventPricing.fullSelfiePrice || event.fullSelfiePrice || null,
            photographerFee: eventPricing.photographerFee || event.photographerFee || null,
        }

        props.updateEvent(event);
    };

    // Sin pricingData el evento es gratuito; removePricing es lo que le dice al backend
    // que lo borre (un pricingData ausente o nulo lo deja como estaba).
    const dispatchRemovePricing = () => {
        const event = { ...props.selectedEvent, removePricing: true };
        delete event.pricingData;
        return props.updateEvent(event);
    };

    return (
        <PricingForm
            user={props.user}
            currency={props.currency}
            event={props?.selectedEvent}
            dispatchUpdate={dispatchUpdateEvent}
            dispatchRemovePricing={dispatchRemovePricing}
            loading={props.loading}
        />
    );
};

const mapStateToProps = state => (
    {
        currency: state.usersReducer.user?.currency,
        user: state.usersReducer.user,
        loading: state.eventsReducer.loading
    }
);

const mapDispatchToProps =
{
    updateEvent,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EventPricing));